import { Box, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import Text from "../../../../../../../../components/Text";
import { useGetPatientScriptsureUrl } from "../../../../../../../../queries/script-sure/use-get-patient-scriptsure-url";
import { getXtenantId } from "../../../../../../../../utils/utils";
import { useState } from "react";
import { ScriptsureIframe } from "../../../../../../../../components/ScriptsureIframe";
import { GetScriptsureProfileUrlTypeEnum } from "../../../../../../../../services";

const EPrescriptions = () => {
  const { patientId } = useParams();
  const user = sessionStorage.getItem("user");

  const providerId = user != "undefined" ? JSON.parse(user ?? "")?.uuid : null;
  const [shouldFetchUrl, setShouldFetchUrl] = useState(true);
  const {
    data: patientScriptsureUrl,
    isLoading,
    error,
  } = useGetPatientScriptsureUrl({
    patientUuid: patientId ?? "",
    providerId: providerId ?? "",
    xTENANTID: getXtenantId() ?? "",
    type: GetScriptsureProfileUrlTypeEnum.Prescription,
    enabled: shouldFetchUrl, // Auto-load on component mount
  });

  // Show loading state
  if (isLoading) {
    return (
      <Box
        width={"100%"}
        height={"100%"}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{ padding: "2rem" }}
      >
        <Text>Loading ScriptSure...</Text>
      </Box>
    );
  }

  // Show error state
  if (error) {
    return (
      <Box
        width={"100%"}
        height={"100%"}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        style={{ padding: "2rem" }}
      >
        <Text style={{ marginBottom: "1rem", color: "red" }}>
          Error loading ScriptSure. Please try again.
        </Text>
        <Button
          onClick={() => setShouldFetchUrl(!shouldFetchUrl)}
          variant="contained"
          size="small"
        >
          Retry
        </Button>
      </Box>
    );
  }

  // Show iframe when data is loaded
  // patientScriptsureUrl?.data || shouldFetchUrl
  if (patientScriptsureUrl?.data || shouldFetchUrl) {
    const url =
      typeof patientScriptsureUrl?.data === "string"
        ? patientScriptsureUrl.data
        : ""; // Fallback URL for testing

    return (
      <Box width={"100%"} height={"100%"}>
        <ScriptsureIframe url={url} width="90%" height="calc(100vh - 300px)" />
      </Box>
    );
  }

  // Show initial state with button to load ScriptSure
  return (
    <Box
      width={"100%"}
      height={"100%"}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ padding: "2rem" }}
    >
      <Text variant="h6" style={{ marginBottom: "1rem" }}>
        E-Prescriptions -
      </Text>
      <Text
        style={{ marginBottom: "2rem", textAlign: "center", color: "#666" }}
      >
        Click the button below to load your ScriptSure patient profile
      </Text>
      <Button
        onClick={() => setShouldFetchUrl(!shouldFetchUrl)}
        variant="contained"
        size="medium"
      >
        Load ScriptSure
      </Button>
    </Box>
  );
};

export default EPrescriptions;
